export const VALIDATION_RULES = {
  MAX_WORKING_DAYS_IN_CYCLE: 5,
  REST_DAYS_AFTER_CYCLE: 1,
  REST_DAYS_AFTER_NIGHT_SHIFT: 2
};
